module.exports = __webpack_public_path__ + "static/media/public-sector-landscape2.47484992.jpg";